import { render, staticRenderFns } from "./tz-form.vue?vue&type=template&id=50c32477&scoped=true&name=tz-form&"
import script from "./tz-form.vue?vue&type=script&lang=js&"
export * from "./tz-form.vue?vue&type=script&lang=js&"
import style0 from "./tz-form.vue?vue&type=style&index=0&id=50c32477&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c32477",
  null
  
)

export default component.exports